"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsEscalationInstanceTable = void 0;
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
var _react = _interopRequireWildcard(require("react"));
var _dmsbasereact = require("dmsbasereact");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const DmsEscalationInstanceTable = () => {
  const table = (0, _react.useRef)(null);
  const header = [{
    label: _reactIntlUniversal.default.get("AlertMessage").d("Alert Message"),
    column_name: "alert_message_pk",
    control: 'select',
    url: "/alert_message/all",
    properties: {
      column_name: "alert_message_pk",
      text_template: '{message}',
      label: "message",
      value: "pk",
      filter: {
        field: 'alert_message_pk',
        value: 'pk'
      }
    },
    filter: true
  }, {
    label: _reactIntlUniversal.default.get("EscalationPolicy").d("Escalation Policy"),
    column_name: "escalation_policy_pk",
    control: 'select',
    url: "/escalation_policy/all",
    properties: {
      column_name: "escalation_policy_pk",
      text_template: '{user_name}',
      label: "user_name",
      value: "pk",
      filter: {
        field: 'escalation_policy_pk',
        value: 'pk'
      }
    },
    filter: true
  }, {
    label: _reactIntlUniversal.default.get("CurrentLevel").d("Current Level"),
    column_name: "current_level",
    filter: true
  }, {
    label: _reactIntlUniversal.default.get("Status").d("Status"),
    column_name: "status",
    filter: true
  }, {
    label: _reactIntlUniversal.default.get("FirstTriggedAt").d("First Trigged At"),
    column_name: "first_triggered_at",
    filter: true
  }, {
    label: _reactIntlUniversal.default.get("LastEscalatedAt").d("Last Escalated At"),
    column_name: "last_escalated_at",
    filter: true
  }, {
    label: _reactIntlUniversal.default.get("ResolvedAt").d("Resolved At"),
    column_name: "resolved_at",
    filter: true
  }, {
    label: _reactIntlUniversal.default.get("ResolvedByPk").d("Resolved By Pk"),
    column_name: "resolved_by_pk",
    filter: true
  }, {
    label: _reactIntlUniversal.default.get("ResolutionNotes").d("Resolution Notes"),
    column_name: "resolution_notes",
    filter: true
  }];
  return /*#__PURE__*/_react.default.createElement(_dmsbasereact.DmsTable, {
    header: header,
    managed: true,
    needs_authentication: true,
    ref: table,
    url: "/escalation_instance/table",
    export_table: false,
    responsive: true
  });
};
exports.DmsEscalationInstanceTable = DmsEscalationInstanceTable;